import React, { FC, useCallback, useState } from 'react';
import { humanize } from 'inflection';

import Button, { BUTTON_WIDTHS } from '@buyside/components/presentation/Button/button';
import FilterChecklist from '@buyside/components/presentation/Filters/FilterChecklist/filterChecklist';
import FilterTextInput from '@buyside/components/presentation/Filters/FilterTextInput/filterTextInput';
import Modal from '@buyside/components/presentation/Modal/modal';
import SelectableDropdown from '@buyside/components/presentation/SelectableDropdown/selectableDropdown';

import { dollarSignify } from '@buyside/util/textHelpers';
import { labelize, labelizeWithDollarSign } from '@buyside/util/arrayHelper';
const { accreditationAnswerMap } = require('buyside/util/constantsFromRails.json');

import styles from './accreditedInvestorIndexPageStyles.scss';

const AccreditedInvestorProfileFilters: FC = () => {
  const [isInvestmentExperienceModalOpen, setIsInvestmentExperienceModalOpen] = useState(false);

  const renderOpenInvestmentExperienceModalButton = useCallback(
    () => (
      <div>
        <Button
          className={styles.filterGroupModalButton}
          onClick={() => setIsInvestmentExperienceModalOpen(true)}
          text="Investment Experience"
          width={BUTTON_WIDTHS.FULL}
        />
      </div>
    ),
    []
  );

  return (
    <>
      <FilterTextInput id="name" placeholder="Name" paramName="user" />
      <SelectableDropdown title="Annual Allocation">
        <FilterChecklist
          paramName="next_12_mo_allocation[]"
          filterList={accreditationAnswerMap.next_12_mo_allocation.map((val: string) => ({
            label: dollarSignify(val),
            value: val
          }))}
        />
      </SelectableDropdown>
      <Modal
        isOpen={isInvestmentExperienceModalOpen}
        onClose={() => setIsInvestmentExperienceModalOpen(false)}
        renderOpenModalButton={renderOpenInvestmentExperienceModalButton}
        size="lg"
        title="Investment Experience"
      >
        <div className={styles.filterGroupGrid}>
          {Object.keys(accreditationAnswerMap)
            .filter(question =>
              [
                'bonds',
                'foreign_currencies',
                'futures_or_commodities',
                'hedge_funds',
                'investment_size',
                'private_companies',
                'private_equity_funds',
                'publicly_traded_stocks',
                'real_estate'
              ].includes(question)
            )
            .map(question => {
              return (
                <FilterChecklist
                  filterList={
                    question === 'investment_size'
                      ? labelizeWithDollarSign(accreditationAnswerMap['investment_size'])
                      : labelize(
                          accreditationAnswerMap[question as keyof typeof accreditationAnswerMap]
                        )
                  }
                  paramName={question + '[]'}
                  title={humanize(question)}
                  key={question}
                />
              );
            })}
        </div>
      </Modal>
      <SelectableDropdown title="Years Investing">
        <FilterChecklist
          paramName="years_investing[]"
          filterList={labelize(accreditationAnswerMap['years_investing'])}
        />
      </SelectableDropdown>
    </>
  );
};

export default AccreditedInvestorProfileFilters;
